import { catchError, firstValueFrom, of } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '../services/AuthService';

export function authInitFactory(auth: AuthService): () => Promise<void> {
  return () => {
    if (!auth.isLoggedIn()) {
      return Promise.resolve();
    }
    return firstValueFrom(
      auth.getMe().pipe(
        catchError((err: HttpErrorResponse) => {
          // 401/403 — токен невалиден или аккаунт отключён: чистим сессию,
          // login.component при инициализации покажет форму.
          // Сетевые / 5xx ошибки — НЕ разлогиниваем; пусть guard'ы при
          // навигации сами решают на основе того, что есть в sessionStorage.
          if (err.status === 401 || err.status === 403) {
            auth.clearSession();
          }
          return of(null);
        })
      )
    ).then(payload => {
      if (payload) {
        auth.setSession(payload, false);
      }
    });
  };
}
